/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_TitleInputs */



/**
* | output |
* | --- |
* | "Compare features side by side" |
*
* @param {Signup_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_title = /** @type {((inputs?: Signup_Compare_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compare features side by side")
	if (locale === "de") return /** @type {LocalizedString} */ ("Compare features side by side")
	if (locale === "it") return /** @type {LocalizedString} */ ("Compare features side by side")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Compare features side by side")
	if (locale === "es") return /** @type {LocalizedString} */ ("Compare features side by side")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Compare features side by side")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Compare features side by side")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Compare features side by side")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Compare features side by side")
	return /** @type {LocalizedString} */ ("Compare features side by side")
});